import { SelectBox } from 'devextreme-react/select-box';
import { NumberBox } from 'devextreme-react/number-box';
import { CheckBox } from 'devextreme-react/check-box';
import { TextBox } from 'devextreme-react/text-box';
import { useDesignerStore } from '../store';

const INDENT_OPTIONS = [
  { value: 'space', label: 'Space-based (single column)' },
  { value: 'column', label: 'Column-based (one per level)' },
];

const AMOUNT_OPTIONS = [
  { value: 'adjacent', label: 'Adjacent (after labels)' },
  { value: 'fixed', label: 'Fixed column position' },
];

export function LayoutSettings() {
  const { layoutSettings, setLayoutSettings } = useDesignerStore();

  return (
    <div className="p-4 space-y-4">
      <h3 className="text-sm font-semibold text-gray-700 uppercase tracking-wider">
        Excel Layout
      </h3>

      {/* Label Formatting */}
      <div className="space-y-3">
        <h4 className="text-xs font-medium text-gray-500 uppercase">Label Formatting</h4>
        <div>
          <label className="block text-xs font-medium text-gray-600 mb-1">Indent Mode</label>
          <SelectBox
            items={INDENT_OPTIONS}
            displayExpr="label"
            valueExpr="value"
            value={layoutSettings.labelIndent}
            onValueChanged={(e) => setLayoutSettings({ labelIndent: e.value })}
          />
        </div>
        {layoutSettings.labelIndent === 'space' && (
          <div>
            <label className="block text-xs font-medium text-gray-600 mb-1">Spaces Per Level</label>
            <NumberBox
              value={layoutSettings.spacesPerLevel}
              min={1}
              max={10}
              showSpinButtons
              onValueChanged={(e) => setLayoutSettings({ spacesPerLevel: e.value })}
            />
          </div>
        )}
      </div>

      {/* Amount Columns */}
      <div className="space-y-3">
        <h4 className="text-xs font-medium text-gray-500 uppercase">Amount Columns</h4>
        <div>
          <label className="block text-xs font-medium text-gray-600 mb-1">Position</label>
          <SelectBox
            items={AMOUNT_OPTIONS}
            displayExpr="label"
            valueExpr="value"
            value={layoutSettings.amountPosition}
            onValueChanged={(e) => setLayoutSettings({ amountPosition: e.value })}
          />
        </div>
        {layoutSettings.amountPosition === 'fixed' && (
          <div>
            <label className="block text-xs font-medium text-gray-600 mb-1">Fixed Column (e.g. E)</label>
            <TextBox
              value={layoutSettings.fixedAmountColumn ?? ''}
              onValueChanged={(e) => setLayoutSettings({ fixedAmountColumn: e.value || undefined })}
              placeholder="E"
              maxLength={2}
            />
          </div>
        )}
      </div>

      {/* Display Settings */}
      <div className="space-y-3">
        <h4 className="text-xs font-medium text-gray-500 uppercase">Display</h4>
        <CheckBox
          text="Show Gridlines"
          value={layoutSettings.showGridlines}
          onValueChanged={(e) => setLayoutSettings({ showGridlines: e.value })}
        />
        <CheckBox
          text="Freeze Header Row"
          value={layoutSettings.freezeHeaderRow}
          onValueChanged={(e) => setLayoutSettings({ freezeHeaderRow: e.value })}
        />
        <CheckBox
          text="Repeat Header on Print"
          value={layoutSettings.repeatHeaderOnPrint}
          onValueChanged={(e) => setLayoutSettings({ repeatHeaderOnPrint: e.value })}
        />
      </div>
    </div>
  );
}
